export default __webpack_public_path__ + "static/media/store_svg8.558d449b.svg";